<template>
  <app-layout>
    <pacman-loader
        v-if="loading"
        :loading="loading"
        color="#3b82f6"
    />

    <template
        v-if="!loading"
    >
      <template v-for="(field, key) in fields" :key="key">
        <div class="mb-4">
          <h1 class="font-medium text-sm text-slate-400">{{ field.text }}</h1>
          <p class="text-xl">{{ data[field.key] }}</p>
        </div>
      </template>
    </template>

  </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import PacmanLoader from 'vue-spinner/src/PacmanLoader.vue';

export default {
  name: "AffiliatesDetail",

  components: {
    AppLayout,
    PacmanLoader,
  },

  data() {
    return {
      model: 'affiliates',
      pageTitle: 'Affiliate details',
      loading: true,
      data: {},
      fields: [
        {text: 'First name', key: 'first_name'},
        {text: 'Last name', key: 'last_name'},
        {text: 'Email', key: 'email'},
        {text: 'Role', key: 'role_name'},
        {text: 'Created date', key: 'created_at_humanized'},
      ],
    }
  },

  created() {
    this.loadData();

    this.$store.dispatch('setNavTitle', this.pageTitle);
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$axios
          .get(`/${this.model}/${this.$route.params.id}/show`)
          .then((response) => {
            this.data = response.data;
            this.loading = false;
          })
          .catch(e => {
            this.$toast.warning(e.data.message);
            this.loading = false;
          });
    },
  },
};
</script>
